// styles
import { chartDashboardBoxStyle, chartDashboardType04Style } from 'styles';

// libraries
import styled from 'styled-components';

interface BarSectionProps {
  width: string;
  color: string;
}

export const StyledProgressChartCard = styled.div`
  ${chartDashboardBoxStyle}
  ${chartDashboardType04Style}
`;

export const ProgressBar = styled.div`
  display: flex;
  width: 100%;
  height: 28px;
  gap: 8px;
  padding: 2px;
  background-color: #f8f8f8;
`;

export const BarSection = styled.div<BarSectionProps>`
  width: ${(props) => props.width};
  background-color: ${(props) => props.color};
  border-radius: 4px;
  transform-origin: left;
  animation: fillBar 1.2s cubic-bezier(0.26, 0.86, 0.44, 0.985) forwards;
  opacity: 0;

  @keyframes fillBar {
    0% {
      transform: scaleX(0);
      opacity: 0;
    }
    100% {
      transform: scaleX(1);
      opacity: 1;
    }
  }

  &:nth-child(2) {
    animation-delay: 0.3s;
  }
  &:nth-child(3) {
    animation-delay: 0.6s;
  }
`;

export const ProgressBarContainer = styled.div`
  &:hover ${BarSection} {
    filter: brightness(1.1);
    transition: filter 0.3s ease;
  }
`;
